<template>
    <div class="goods-car">
        <div v-if="goodsList.length"
             :class="[{ 'is-compile': isCompile }]">
            <van-cell>
                <template slot="title">
                    <van-icon name="shopping-cart-o"
                              class="cart-icon" />
                    <span>购物车</span>
                </template>
                <template>
                    <span @click="isCompile = !isCompile">
                        {{ isCompile ? '退出管理' : '管理' }}
                    </span>
                </template>
            </van-cell>
            <van-checkbox-group v-model="selectAll"
                                class="goods-list"
                                ref="checkboxGroup">
                <van-checkbox v-for="item in goodsList"
                              v-model="item.checked"
                              :key="item.id"
                              :name="item.id"
                              @click="slectCheck(item)"
                              style="margin-top: 10px">
                    <van-swipe-cell>
                        <van-card :price="item.productPrice"
                                  :title="item.productName"
                                  class="goods-card">
                            <template #num
                                      v-if="!isCompile">
                                <div class="goods-num"
                                     @click.stop>
                                    <van-stepper v-model="item.quantity"
                                                 step="1"
                                                 :button-size="'22px'"
                                                 @change="updateProductCount(item)" />
                                </div>
                            </template>
                        </van-card>
                    </van-swipe-cell>
                </van-checkbox>
            </van-checkbox-group>
            <van-submit-bar :price="price">
                <van-checkbox :value="checkedAll"
                              @click="toggleAll">
                    全选
                </van-checkbox>
                <template #button>
                    <template v-if="isCompile">
                        <van-button type="danger"
                                    @click="onSubmit(1)"
                                    round
                                    style="width: 110px">删除 </van-button>
                    </template>
                    <template v-else>
                        <van-button type="info"
                                    @click="onSubmit(2)"
                                    round
                                    style="width: 110px"> 立即购买 </van-button>
                    </template>
                </template>
            </van-submit-bar>
        </div>
        <div v-else>
            <van-empty description="购物车暂时没有商品" />
        </div>
    </div>
</template>

<script>
import api_sale from '../../services/saleLogin.js';
import Vue from 'vue';
import {
    SubmitBar,
    Checkbox,
    CheckboxGroup,
    Card,
    SwipeCell,
    Button,
    Stepper,
    Cell,
    CellGroup,
    Empty,
    Toast,
    Image as VanImage,
    Icon,
} from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(SubmitBar);
Vue.use(Card);
Vue.use(SwipeCell);
Vue.use(Button);
Vue.use(Stepper);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Empty);
Vue.use(VanImage);
Vue.use(Toast);
Vue.use(Icon);

export default {
    name: 'goods-car',
    data() {
        return {
            patientId: this.$store.getters.getUserInfo.patientId,
            selectAll: [],
            isCompile: false,
            goodsList: [],
            address: [],
        };
    },
    computed: {
        price() {
            let priceList = this.goodsList.filter((item) =>
                this.selectAll.includes(item.id)
            );
            if (priceList.length) {
                return (
                    priceList
                        .map(
                            (item) =>
                                (item.quantity || 0) * (item.productPrice || 0)
                        )
                        .reduce((a, b) => a + b) * 100
                );
            }
            return 0;
        },
        checkedAll() {
            return this.selectAll.length >= this.goodsList.length;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getGoodsList();
            // this.getUseraddress();
        },
        //获取购物车列表
        getGoodsList() {
            this.$indicator.open('加载中...');
            api_sale.getShopList({ patientId: this.patientId }).then((res) => {
                this.$indicator.close();
                let data = res.data.data || [];
                data.forEach((item) => {
                    item.checked = item.checked == 2;
                    if (item.checked) {
                        this.selectAll.push(item.id);
                    }
                });
                this.goodsList = data;
            });
        },
        // 获取收获地址
        getUseraddress() {
            this.$indicator.open('加载中...');
            api_sale
                .getUserAddress({
                    patientId: this.$store.getters.getUserInfo.patientId,
                })
                .then((res) => {
                    this.$indicator.close();
                    this.address = res.data.data;
                });
        },
        toggleAll() {
            if (!this.checkedAll) {
                this.$set(
                    this,
                    'selectAll',
                    this.goodsList.map((item) => item.id)
                );
            } else {
                this.$set(this, 'selectAll', []);
            }
            this.productUnCheckedAll(!this.checkedAll);
        },
        //删除单项
        delectItem(id, index) {
            const params = {
                patientId: this.$store.getters.getUserInfo.patientId,
                productId: id,
            };
            this.$indicator.open('加载中...');
            api_sale.delectItem(params).then((res) => {
                this.$toast('移除成功');
                this.$indicator.close();
            });
            this.goodsList.splice(index, 1);
        },
        updateProductCount(item) {
            const params = {
                patientId: this.$store.getters.getUserInfo.patientId,
                productId: item.productId,
                count: item.quantity,
            };
            this.$indicator.open('加载中...');
            api_sale.updateProductCount(params).then((res) => {
                this.$indicator.close();
            });
        },
        productUnCheckedAll(isCedAll) {
            const params = {
                patientId: this.$store.getters.getUserInfo.patientId,
            };
            this.$indicator.open('加载中...');
            if (!isCedAll) {
                api_sale.productCheckedAll(params).then((res) => {
                    this.$indicator.close();
                });
            } else {
                api_sale.productUnCheckedAll(params).then((res) => {
                    this.$indicator.close();
                });
            }
        },
        slectCheck(item) {
            item.checked = !item.checked;
            let proxy = item.checked ? 'productChecked' : 'productUnChecked';
            this.$indicator.open('加载中...');
            api_sale[proxy]({
                patientId: this.patientId,
                productId: item.productId,
            }).then(
                (res) => {
                    this.$indicator.close();
                },
                (err) => {
                    this.$indicator.close();
                }
            );
        },
        onSubmit(type) {
            const length = this.selectAll.length;
            if (!length) {
                this.$toast(`请勾选需要${type == 1 ? '删除' : '购买'}的商品`);
                return;
            }
            const goodsList = this.goodsList.filter((item) =>
                this.selectAll.includes(item.id)
            );
            if (this.isCompile) {
                goodsList.forEach((item, index) => {
                    this.delectItem(item.productId, index);
                });
                return;
            } else {
                this.$store.commit('setGoodsList', goodsList);
                this.$router.push({
                    name: 'shopAddressList',
                    query: { type: 1 },
                });
                return;
            }
        },
    },
};
</script>

<style lang="less">
.goods-car {
    height: 100%;
    background-color: rgb(250, 250, 250);

    .cart-icon {
        font-size: 18px;
        margin-right: 10px;
        color: #208fe3;
    }

    .goods-list {
        .van-checkbox {
            margin: 0 10px;
            padding-left: 10px;
            background-color: #ffffff;

            .goods-card {
                margin: 0;
                background-color: #ffffff;
            }

            .delete-button {
                height: 100%;
            }

            .van-checkbox__label {
                width: 100%;
            }
        }
    }

    .van-card__content {
        min-height: 60px;
    }

    .van-submit-bar {
        .van-checkbox {
            height: 23px;
            padding-top: 3px;
        }
    }

    .is-compile {
        .van-submit-bar__text {
            span {
                display: none;
            }
        }
    }
    .goods-num {
        display: flex;
        align-items: center;
        column-gap: 12px;
        .van-icon {
            font-size: 16px;
        }
    }
}
</style>
